import moment from 'moment';

export const formatDate = (date: string | Date | undefined): string => {
  if (!date) {
    return ''
  }
  return moment(date).format('DD MMMM YYYY, HH:mm');
};
